/**
 * Prototypes
 * @returns {*}
 */

/**
 * formats a string by replacing the {} replacement tokens with given variable values
 * Example:
 * $scope.oneLineAddress = "{} {}, {}, {} {} {}".format(
 *      fullAddress.address_line_1,
 *      fullAddress.address_line_2,
 *      fullAddress.city,
 *      fullAddress.state,
 *      fullAddress.postal_code,
 *      fullAddress.country
 * );
 * @returns {*}
 */
String.prototype.format = function () {
    var i = 0, args = arguments;
    return this.replace(/{}/g, function () {
        return typeof args[i] != 'undefined' ? args[i++] : '';
    });
};